// Chaînes d'évolution générées depuis zeroxm/pokemon-roulette.
// Ne pas éditer à la main — régénérer via `npm run generate:pokedex`.
// Source : https://raw.githubusercontent.com/zeroxm/pokemon-roulette/main/src/app/services/evolution-service/evolution-chain.ts

export const EVOLUTION_CHAIN: Readonly<Record<number, readonly number[]>> = {
  1: [2],
  2: [3],
  4: [5],
  5: [6],
  7: [8],
  8: [9],
  10: [11],
  11: [12],
  13: [14],
  14: [15],
  16: [17],
  17: [18],
  19: [20],
  21: [22],
  23: [24],
  25: [26, 10100],
  27: [28],
  29: [30],
  30: [31],
  32: [33],
  33: [34],
  35: [36],
  37: [38],
  39: [40],
  41: [42],
  42: [169],
  43: [44],
  44: [45, 182],
  46: [47],
  48: [49],
  50: [51],
  52: [53],
  54: [55],
  56: [57],
  57: [979],
  58: [59],
  60: [61],
  61: [62, 186],
  63: [64],
  64: [65],
  66: [67],
  67: [68],
  69: [70],
  70: [71],
  72: [73],
  74: [75],
  75: [76],
  77: [78],
  79: [80, 199],
  81: [82],
  82: [462],
  83: [865],
  84: [85],
  86: [87],
  88: [89],
  90: [91],
  92: [93],
  93: [94],
  95: [208],
  96: [97],
  98: [99],
  100: [101],
  102: [103, 10114],
  104: [105, 10115],
  108: [463],
  109: [110, 10167],
  111: [112],
  112: [464],
  113: [242],
  114: [465],
  116: [117],
  117: [230],
  118: [119],
  120: [121],
  123: [212, 900],
  125: [466],
  126: [467],
  129: [130],
  133: [134, 135, 136, 196, 197, 470, 471, 700],
  137: [233],
  138: [139],
  140: [141],
  147: [148],
  148: [149],
  152: [153],
  153: [154],
  155: [156],
  156: [157, 10233],
  158: [159],
  159: [160],
  161: [162],
  163: [164],
  165: [166],
  167: [168],
  170: [171],
  172: [25],
  173: [35],
  174: [39],
  175: [176],
  176: [468],
  177: [178],
  179: [180],
  180: [181],
  183: [184],
  187: [188],
  188: [189],
  190: [424],
  191: [192],
  193: [469],
  194: [195],
  198: [430],
  200: [429],
  203: [981],
  204: [205],
  206: [982],
  207: [472],
  209: [210],
  211: [904],
  215: [461],
  216: [217],
  217: [901, 10272],
  218: [219],
  220: [221],
  221: [473],
  222: [864],
  223: [224],
  228: [229],
  231: [232],
  233: [474],
  234: [899],
  236: [106, 107, 237],
  238: [124],
  239: [125],
  240: [126],
  246: [247],
  247: [248],
  252: [253],
  253: [254],
  255: [256],
  256: [257],
  258: [259],
  259: [260],
  261: [262],
  263: [264],
  265: [266, 268],
  266: [267],
  268: [269],
  270: [271],
  271: [272],
  273: [274],
  274: [275],
  276: [277],
  278: [279],
  280: [281],
  281: [282, 475],
  283: [284],
  285: [286],
  287: [288],
  288: [289],
  290: [291, 292],
  293: [294],
  294: [295],
  296: [297],
  298: [183],
  299: [476],
  300: [301],
  304: [305],
  305: [306],
  307: [308],
  309: [310],
  315: [407],
  316: [317],
  318: [319],
  320: [321],
  322: [323],
  325: [326],
  328: [329],
  329: [330],
  331: [332],
  333: [334],
  339: [340],
  341: [342],
  343: [344],
  345: [346],
  347: [348],
  349: [350],
  353: [354],
  355: [356],
  356: [477],
  360: [202],
  361: [362, 478],
  363: [364],
  364: [365],
  366: [367, 368],
  371: [372],
  372: [373],
  374: [375],
  375: [376],
  387: [388],
  388: [389],
  390: [391],
  391: [392],
  393: [394],
  394: [395],
  396: [397],
  397: [398],
  399: [400],
  401: [402],
  403: [404],
  404: [405],
  406: [315],
  408: [409],
  410: [411],
  412: [413, 414],
  415: [416],
  418: [419],
  420: [421],
  422: [423],
  425: [426],
  427: [428],
  431: [432],
  433: [358],
  434: [435],
  436: [437],
  438: [185],
  439: [122],
  440: [113],
  443: [444],
  444: [445],
  446: [143],
  447: [448],
  449: [450],
  451: [452],
  453: [454],
  456: [457],
  458: [226],
  459: [460],
  495: [496],
  496: [497],
  498: [499],
  499: [500],
  501: [502],
  502: [503, 10236],
  504: [505],
  506: [507],
  507: [508],
  509: [510],
  511: [512],
  513: [514],
  515: [516],
  517: [518],
  519: [520],
  520: [521],
  522: [523],
  524: [525],
  525: [526],
  527: [528],
  529: [530],
  532: [533],
  533: [534],
  535: [536],
  536: [537],
  540: [541],
  541: [542],
  543: [544],
  544: [545],
  546: [547],
  548: [549, 10237],
  550: [902, 10248],
  551: [552],
  552: [553],
  554: [555],
  557: [558],
  559: [560],
  562: [563],
  564: [565],
  566: [567],
  568: [569],
  570: [571],
  572: [573],
  574: [575],
  575: [576],
  577: [578],
  578: [579],
  580: [581],
  582: [583],
  583: [584],
  585: [586],
  588: [589],
  590: [591],
  592: [593],
  595: [596],
  597: [598],
  599: [600],
  600: [601],
  602: [603],
  603: [604],
  605: [606],
  607: [608],
  608: [609],
  610: [611],
  611: [612],
  613: [614],
  616: [617],
  619: [620],
  622: [623],
  624: [625],
  625: [983],
  627: [628, 10240],
  629: [630],
  633: [634],
  634: [635],
  636: [637],
  650: [651],
  651: [652],
  653: [654],
  654: [655],
  656: [657],
  657: [658],
  659: [660],
  661: [662],
  662: [663],
  664: [665],
  665: [666],
  667: [668],
  669: [670],
  670: [671],
  672: [673],
  674: [675],
  677: [678, 10025],
  679: [680],
  680: [681, 10026],
  682: [683],
  684: [685],
  686: [687],
  688: [689],
  690: [691],
  692: [693],
  694: [695],
  696: [697],
  698: [699],
  704: [705, 10241],
  705: [706],
  708: [709],
  710: [711],
  712: [713, 10243],
  714: [715],
  718: [10120],
  722: [723],
  723: [724, 10244],
  725: [726],
  726: [727],
  728: [729],
  729: [730],
  731: [732],
  732: [733],
  734: [735],
  736: [737],
  737: [738],
  739: [740],
  742: [743],
  744: [745, 10126, 10152],
  747: [748],
  749: [750],
  751: [752],
  753: [754],
  755: [756],
  757: [758],
  759: [760],
  761: [762],
  762: [763],
  767: [768],
  769: [770],
  772: [773],
  782: [783],
  783: [784],
  789: [790],
  790: [791, 792],
  803: [804],
  808: [809],
  810: [811],
  811: [812],
  813: [814],
  814: [815],
  816: [817],
  817: [818],
  819: [820],
  821: [822],
  822: [823],
  824: [825],
  825: [826],
  827: [828],
  829: [830],
  831: [832],
  833: [834],
  835: [836],
  837: [838],
  838: [839],
  840: [841, 842, 1011],
  843: [844],
  846: [847],
  848: [849, 10184],
  850: [851],
  852: [853],
  854: [855],
  856: [857],
  857: [858],
  859: [860],
  860: [861],
  868: [869],
  872: [873],
  878: [879],
  884: [1018],
  885: [886],
  886: [887],
  891: [892],
  906: [907],
  907: [908],
  909: [910],
  910: [911],
  912: [913],
  913: [914],
  915: [916, 10254],
  917: [918],
  919: [920],
  921: [922],
  922: [923],
  924: [925, 10257],
  926: [927],
  928: [929],
  929: [930],
  932: [933],
  933: [934],
  935: [936, 937],
  938: [939],
  940: [941],
  942: [943],
  944: [945],
  946: [947],
  948: [949],
  951: [952],
  953: [954],
  955: [956],
  957: [958],
  958: [959],
  960: [961],
  963: [964],
  965: [966],
  969: [970],
  971: [972],
  974: [975],
  996: [997],
  997: [998],
  999: [1000],
  1011: [1019],
  1012: [1013],
  10101: [10102],
  10105: [10106],
  10107: [10108],
  10109: [10110],
  10110: [10111],
  10112: [10113],
  10118: [10119],
  10119: [10120],
  10161: [863],
  10162: [10163],
  10164: [10165, 10172],
  10166: [865],
  10168: [866],
  10173: [864],
  10175: [862],
  10176: [10177],
  10179: [867],
  10181: [10119],
  10229: [10230],
  10231: [10232],
  10234: [904],
  10235: [903],
  10238: [10239],
  10241: [10242],
  10253: [980],
} as const;
